import React, { FC } from 'react';
import styles from './FlickrIcon.scss';

export const FlickrIcon: FC = () => <div className={styles.flickrIcon} />;
